/**
 *
 */

import $ from 'jquery';

export default class Title {

	constructor(options) {
		this.id = options.id;
		this.rootId = options.rootId;
		this.className = this.rootId + '__title';
		this.title = document.getElementById(this.id);
	}

	/**
	 * @param    Object
	 * @chainable
	 */
	configure(data) {
		this.activeTaxonomy = data.taxonomy;
		// @todo refactor this hack
		this.title.innerHTML = data.taxonomy.toUpperCase();
		return this;
	}

	/**
	 * @todo
	 */
	toggle() {
	}

	/**
	 *  @chainable
	 */
	show() {
		$(this.title).removeClass(this.className + '--inactive');
		$(this.title).addClass(this.className + '--active');
		return this;
	}

	/**
	 * @chainable
	 */
	hide() {
		$(this.title).removeClass(this.className + '--active');
		$(this.title).addClass(this.className + '--inactive');
		return this;
	}

}